import { useState } from "react";
import { cn } from "../../../shared/utils/cn";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: "primary" | "admin";
  innerClassName?: string;
  inputClassName?: string;
  error?: {
    message: string;
    isMessageVisible: boolean;
    isIconVisible: boolean;
  };
}

const TextInput: React.FC<Props> = ({
  variant = "primary",
  maxLength,
  placeholder,
  className,
  innerClassName = "",
  inputClassName = "",
  id,
  error,
  onFocus,
  onBlur,
  ...props
}) => {
  const baseClass = "flex flex-row justify-between border";

  const variantClasses = {
    div: {
      primary:
        "bg-white rounded-[8px] border border-separate border-tools-table-outline p-3",
      admin: "rounded-[8px] p-[11.5px] bg-transparent",
    },
    input: {
      primary: "w-full / text-sm / bg-white",
      admin: "bg-transparent w-full text-[14px] outline-none",
    },
  };

  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className={`w-full ${className}`}>
      <div className={`text-start flex flex-col ${innerClassName} rounded-[8px]`}>
        <div
          className={`relative items-center
        ${baseClass} ${cn(variantClasses.div[variant])}
        ${error?.message ? "border-[#F24A4A]" : ""}
        ${isFocused && !error?.message ? "border-[#4285F4]" : ""}
        ${!isFocused && !error?.message ? "border-[#d9d9d9]" : ""}
         h-full
         pr-3`}
        >
          <input
            {...props}
            id={id}
            placeholder={placeholder}
            className={`${error?.message && error?.isIconVisible ? "pr-6" : ""} outline-none ${cn(variantClasses.input[variant])} ${inputClassName}`}
            maxLength={maxLength}
            onFocus={(e) => {
              setIsFocused(true);
              onFocus?.(e);
            }}
            onBlur={(e) => {
              setIsFocused(false);
              onBlur?.(e);
            }}
          />
          {error?.message && error.isIconVisible ? (
            <div className="flex items-center absolute top-0 bottom-0 right-[0.7188rem]">
              <img
                className="w-[1.2213rem]"
                alt="alert icon"
                src="/assets/icons/alerticon.svg"
              />
            </div>
          ) : null}
        </div>
      </div>
      {error?.isMessageVisible && error?.message ? (
        <div className="text-[12px] text-left mt-[0.25rem] text-[#F24A4A]">
          {error?.message}
        </div>
      ) : null}
    </div>
  );
};

export default TextInput;
